import { render } from "./MarketDetail.vue?vue&type=template&id=72dd10aa&scoped=true"
import script from "./MarketDetail.vue?vue&type=script&lang=js"
export * from "./MarketDetail.vue?vue&type=script&lang=js"

import "./MarketDetail.vue?vue&type=style&index=0&id=72dd10aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72dd10aa"]])

export default __exports__